import Common from './lib/Common';
import docsearch from 'docsearch.js';

const common = Common(".");
const offline = common.isOffline();
const pathname =  window.location.pathname.replace(/\+/g, '%20');
const urldocument = pathname.substring(0, pathname.lastIndexOf('/')) + '/';
const filters = $('#navbar-search').data('algolia-filters');
const appId = $('#navbar-search').data('algolia-app-id');
const apiKey = $('#navbar-search').data('algolia-api-key');
const indexName = $('#navbar-search').data('algolia-index-name');

if (!offline && apiKey) {
  docsearch({
    appId: appId,
    apiKey: apiKey,
    indexName: indexName,
    inputSelector: '#search input[type=text]',
    algoliaOptions: {
      hitsPerPage: 10,
      filters: (filters ? filters : "urldocument:" + urldocument + " AND format:web")
    },
  });
}
